interface Props {
  step: number; // 0-based index of the current step
  totalSteps: number;
  onStepClick?: (index: number) => void;
}

export function StepIndicator({step, totalSteps, onStepClick}: Props) {
  return (
    <div className='flex w-full gap-1'>
      {Array.from({length: totalSteps}).map((_, i) => {
        const filled = i <= step;
        const clickable = Boolean(onStepClick) && i < step;
        return (
          <button
            key={i}
            type='button'
            disabled={!clickable}
            onClick={() => onStepClick?.(i)}
            aria-label={`Go to step ${i + 1}`}
            className={`group flex-1 ${clickable ? 'cursor-pointer' : 'cursor-default'}`}>
            <div
              className={`h-1 transition-colors duration-300 ${
                filled ? 'bg-iq-orange' : 'bg-white/50'
              } ${clickable ? 'group-hover:bg-iq-orange/60' : ''}`}
            />
          </button>
        );
      })}
    </div>
  );
}
